import { actionCreator } from 'services/store/types';
import { LoginAction } from '../types';
import authActionNames from './constants';
import LoginActionProvider from './loginActionProvider';

export const loginToApp = actionCreator<void>(authActionNames.LOGIN_TO_APP);

export const loginWithCredentials = (userData: {
  email: string;
  password: string;
}): LoginAction =>
  LoginActionProvider.credentials(userData.email, userData.password);

export const loginWithGoogle = (token: string): LoginAction =>
  LoginActionProvider.google(token);

export const loginWithFacebook = (token: string): LoginAction =>
  LoginActionProvider.facebook(token);

export const registerAndLogin = actionCreator<{
  userData: { email: string; password: string; cloudflareToken: string };
  consentPreference: { general: boolean };
}>(authActionNames.REGISTER_AND_LOGIN);

export const loginSuccess = actionCreator<void>(authActionNames.LOGIN_SUCCESS);

export const logout = actionCreator<void>(authActionNames.LOGOUT);

export const logoutSuccess = actionCreator<void>(
  authActionNames.LOGOUT_SUCCESS
);

export const addRedirectParam = actionCreator<{
  to: string;
  actionRequired: boolean;
  hash?: string;
  params?: Record<string, unknown>;
}>(authActionNames.ADD_REDIRECT_PARAM);

export const resetRedirectParam = actionCreator<void>(
  authActionNames.RESET_REDIRECT_PARAM
);
